import type { INode } from '@ardoq/yfiles';
import { type CollapsibleGraphGroup, type GraphNode } from '@ardoq/graph';
import {
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
  measureNodeLabel,
} from '@ardoq/graph-labeling';
import { MODERNIZED_BLOCK_DIAGRAM_COLLAPSED_COMPONENT_GROUP_STRIPE_HEIGHT as STRIPE_HEIGHT } from 'tabview/blockDiagram/view/yFilesExtensions/modernized/consts';
import {
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_SHAPE_HEIGHT as SHAPE_HEIGHT,
  MODERNIZED_BLOCK_DIAGRAM_NODE_LABEL_MARGIN as LABEL_MARGIN,
  MODERNIZED_BLOCK_DIAGRAM_NODE_WIDTH as NODE_WIDTH,
  MODERNIZED_BLOCK_DIAGRAM_LEAF_NODE_PADDING as PADDING,
  MODERNIZED_BLOCK_DIAGRAM_LABEL_MAX_LINES as MAX_LINES,
  MODERNIZED_BLOCK_DIAGRAM_COLLAPSED_COMPONENT_GROUP_HEIGHT as COLLAPSED_COMPONENT_GROUP_HEIGHT,
} from '../consts';
import { wrapString } from 'tabview/blocks/misc/string';

/** @returns the height of the node representation and the main label. based on this, content will be vertically centered within the node bounds. */
const collapsedComponentGroupContentHeight = (node: INode) => {
  const { tag } = node;

  const graphNode = tag as GraphNode | CollapsibleGraphGroup | null;
  if (!graphNode) {
    return 0;
  }
  const itemLabels = graphNode.getItemLabels();
  if (!itemLabels?.mainLabel) {
    return SHAPE_HEIGHT;
  }
  const { mainLabel } = itemLabels;

  const availableWidth = NODE_WIDTH - 2 * PADDING;
  const wrappedLabel = wrapString(
    mainLabel,
    availableWidth,
    measureNodeLabel,
    MAX_LINES
  );
  const mainLabelHeight = wrappedLabel.length * LINE_HEIGHT;

  return SHAPE_HEIGHT + (mainLabelHeight ? LABEL_MARGIN + mainLabelHeight : 0);
};

const collapsedComponentGroupContentCenterY = () =>
  STRIPE_HEIGHT + (COLLAPSED_COMPONENT_GROUP_HEIGHT - STRIPE_HEIGHT) / 2;
/** @returns the y-position of the top of the shape, relative to the top of the node, in New Block Diagram leaf node. */
const collapsedComponentGroupShapeY = (node: INode) => {
  const contentHeight = collapsedComponentGroupContentHeight(node);
  const centerY = collapsedComponentGroupContentCenterY();

  return centerY - contentHeight / 2;
};
export { collapsedComponentGroupShapeY };
